import { render, staticRenderFns } from "./CartNotLogin.vue?vue&type=template&id=3fae9b04&scoped=true"
import script from "./CartNotLogin.vue?vue&type=script&lang=js"
export * from "./CartNotLogin.vue?vue&type=script&lang=js"
import style0 from "./CartNotLogin.vue?vue&type=style&index=0&id=3fae9b04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fae9b04",
  null
  
)

export default component.exports